import { EditAppointmentType } from 'RestAPIs/activities/types';
import { createContext } from 'react';

export const ListViewContext = createContext<{
  onClose: (() => void) | undefined;
  onHandleSelect?: ((...props: any) => void) | undefined;
  onHandleDisconnectAppointmentConfirmation:
    | ((editAppointmentType: EditAppointmentType) => void)
    | undefined;
  isLoading: boolean;
}>({
  onClose: undefined,
  onHandleSelect: undefined,
  onHandleDisconnectAppointmentConfirmation: undefined,
  isLoading: false
});
